export const normalizeProductOptionDefinitions = (value = []) => {
  if (!Array.isArray(value)) {
    return [];
  }

  const seenIds = new Set();

  return value
    .map((optionSet) => {
      const id = String(optionSet?.id || optionSet?.key || "").trim();
      const name = String(optionSet?.name || optionSet?.label || "").trim();
      const options = Array.isArray(optionSet?.options)
        ? optionSet.options
        : typeof optionSet?.options === "string"
          ? optionSet.options.split(",")
          : [];

      const normalizedOptions = Array.from(new Set(options.map((entry) => String(entry).trim()).filter(Boolean)));

      if (!id || !name || normalizedOptions.length === 0 || seenIds.has(id)) {
        return null;
      }

      seenIds.add(id);
      return { id, name, options: normalizedOptions };
    })
    .filter(Boolean);
};

export const normalizeProductOptionValues = (value = {}) => {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return {};
  }

  return Object.keys(value)
    .sort()
    .reduce((accumulator, key) => {
      const normalizedValues = Array.isArray(value[key])
        ? Array.from(new Set(value[key].map((entry) => String(entry).trim()).filter(Boolean)))
        : [];

      if (normalizedValues.length > 0) {
        accumulator[key] = normalizedValues;
      }

      return accumulator;
    }, {});
};

export const getConfiguredProductOptions = (definitions = [], productOptionValues = {}) => {
  const normalizedDefinitions = normalizeProductOptionDefinitions(definitions);
  const normalizedProductOptionValues = normalizeProductOptionValues(productOptionValues);

  return normalizedDefinitions
    .map((optionSet) => {
      const availableValues = normalizedProductOptionValues[optionSet.id] || [];
      const options = optionSet.options.filter((option) => availableValues.includes(option));

      if (options.length === 0) {
        return null;
      }

      return {
        ...optionSet,
        options,
      };
    })
    .filter(Boolean);
};

export const hasConfiguredProductOptions = (product) => Object.values(normalizeProductOptionValues(product?.product_option_values)).some((values) => values.length > 0);

export const normalizeSelectedOptions = (value = {}) => {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return {};
  }

  return Object.keys(value)
    .sort()
    .reduce((accumulator, key) => {
      const option = value[key];
      const name = String(option?.name || "").trim();
      const selectedValue = String(option?.value || "").trim();

      if (name && selectedValue) {
        accumulator[key] = { name, value: selectedValue };
      }

      return accumulator;
    }, {});
};

export const getSelectedOptionsKey = (value = {}) => JSON.stringify(normalizeSelectedOptions(value));

export const getSelectedOptionsList = (value = {}) => Object.values(normalizeSelectedOptions(value));